import { map } from 'rxjs/operators/map';
import { AreaSerializer } from '../../models';
import ajax from '../../utils/ajax';

function sortName(s1, s2) {
  return s1.value.localeCompare(
    s2.value,
    'en-US',
    { numeric: true, sensitivity: 'base' }
  );
}

class AreaService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/areas';
  singlePath = '/networkAsset/airfinder/area';

  /**
    Create an Area
    @param {Object} area
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (area, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}`,
        body: AreaSerializer.serialize(area),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => AreaSerializer.normalize(data.response)));
  };

  /**
    Update an Area
    @param {Object} area
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
 update = (area, store) => {
   let areaid = area.id;
  return ajax(
    {
      url: `${this.conductorUrl}${this.singlePath}/${areaid}`,
      body: AreaSerializer.serializeForUpdate(area),
      headers: { 'Content-Type': 'application/json' },
      method: 'PUT',
      responseType: 'json'
    },
    store
  ).pipe(map(data => AreaSerializer.normalize(data.response)));
};


  /**
    Delete an Area
    @param {String} areaId
    @param {Object} store Redux store
    @returns {Observable}
  */
  delete = (areaId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.singlePath}/${areaId}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };

  /**
    Get Areas in a site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  getBySiteId = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.sort(sortName).map(AreaSerializer.normalize)));
  };
}

export default new AreaService();



// WEBPACK FOOTER //
// ./src/services/area/index.js